import {Fancybox} from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";

document.addEventListener('DOMContentLoaded', function () {
    Fancybox.bind('[data-fancybox]', {
        caption: function () {
            return ``;
        },
        keyboard: {
            ArrowUp: false,
            ArrowDown: false,
        },
    });

    Fancybox.defaults.Hash = false;

    document.addEventListener('click', function (e) {
        if (e.target.closest('.tr-sdg-goals-item-popup-nav__next')) {
            e.preventDefault();
            const fancyNext = document.querySelector('.is-next');
            fancyNext?.click();
        }

        if (e.target.closest('.tr-sdg-goals-item-popup-nav__prev')) {
            e.preventDefault();
            const fancyPrev = document.querySelector('.is-prev');
            fancyPrev?.click();
        }

        if (e.target.closest('.tr-sdg-goals-item-popup__close')) {
            e.preventDefault();
            const closeBtn = e.target.closest('.tr-sdg-goals-item-popup').querySelector('.carousel__button.is-close');
            closeBtn?.click();
        }
    });
});
